"use strict";

var _interopRequireDefault = require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addApply = addApply;
exports.changeState = changeState;
exports.getApply = getApply;
exports.getApplyList = getApplyList;
exports.updateApply = updateApply;
var _request = _interopRequireDefault(require("@/utils/request"));
function getApplyList(params) {
  return (0, _request.default)({
    url: '/api/v1/apply',
    method: 'get',
    params: params
  });
}
function getApply(id) {
  return (0, _request.default)({
    url: "/api/v1/apply/".concat(id),
    method: 'get'
  });
}
function addApply(data) {
  return (0, _request.default)({
    url: '/api/v1/apply',
    method: 'post',
    data: data
  });
}

// patch
function updateApply(data) {
  return (0, _request.default)({
    url: "/api/v1/apply/".concat(data.id),
    method: 'patch',
    data: data
  });
}
function changeState(data) {
  return (0, _request.default)({
    url: "/api/v1/apply/".concat(data.id),
    method: 'post',
    data: data
  });
}